import { Purchases } from '@revenuecat/purchases-js'

async function configure(userId: string) {
  Purchases.configure(
    process.env.EXPO_PUBLIC_REVENUE_CAT_WEB_API_KEY || '',
    userId
  )
}

// Switches to the organization first if needed, so we never read another org's entitlements
async function getCustomerInfo(organizationId: string) {
  if (!Purchases.isConfigured()) {
    return
  }

  const purchases = Purchases.getSharedInstance()
  if (purchases.getAppUserId() !== organizationId) {
    return purchases.changeUser(organizationId)
  }

  return purchases.getCustomerInfo()
}

async function isConfigured() {
  return Purchases.isConfigured()
}

async function logIn(userId: string) {
  return Purchases.getSharedInstance().changeUser(userId)
}

async function showPaywall() {
  const customerInfo = await Purchases.getSharedInstance().getCustomerInfo()
  window.location.href = `${process.env.EXPO_PUBLIC_REVENUE_CAT_WEB_PAYWALL_LINK}/${customerInfo.originalAppUserId}`
}

// The web SDK does not support customer info update listeners
function addCustomerInfoUpdateListener(
  _listener: (customerInfo: unknown) => void
): void {}

function removeCustomerInfoUpdateListener(
  _listener: (customerInfo: unknown) => void
): void {}

export default {
  addCustomerInfoUpdateListener,
  configure,
  getCustomerInfo,
  isConfigured,
  logIn,
  removeCustomerInfoUpdateListener,
  showPaywall,
}
